// Counts the pages of a PDF entirely in the browser (the file is never
// uploaded for this check) using pdfjs-dist. Used to enforce a page cap on
// document evidence before a dispute is submitted — page count, not byte size,
// is what drives AI token cost and hits provider page limits (e.g. Anthropic
// caps PDFs at 100 pages on 200k-context models).
//
// pdfjs is loaded with a dynamic import so it's code-split into its own chunk
// and only fetched when a user actually picks a PDF.

let workerConfigured = false;

// Returns the number of pages in a PDF File/Blob. Throws if the file can't be
// parsed (e.g. corrupt or password-protected) — callers should decide whether
// to fail open or closed on that.
export async function countPdfPages(file) {
  const pdfjsLib = await import("pdfjs-dist/legacy/build/pdf");

  // Bundle the worker as an asset (CRA 5 / webpack 5 resolves new URL +
  // import.meta.url at build time — no CDN, fully self-hosted). Idempotent.
  if (!workerConfigured) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
      "pdfjs-dist/legacy/build/pdf.worker.min.js",
      import.meta.url
    ).toString();
    workerConfigured = true;
  }

  const buf = await file.arrayBuffer();
  const doc = await pdfjsLib.getDocument({ data: new Uint8Array(buf) }).promise;
  try {
    return doc.numPages;
  } finally {
    doc.destroy();
  }
}
